import React from 'react';
import Styles from './styles.js';
const Requirements = () => {
  return (
    <div>
      <div className="flex justify-center xl:px-5 2xl:px-4 pb-4">
        <div className=" md:w-[70%] w-full lg:[w-60%]">
          <div className="lg:container mx-auto">
            <p className="fs-14-21 fw-400" style={{ fontFamily: 'Josefin Sans', color: '#5e5e5e' }}>
              *accepted documents include - Passport, Canadian photo IDs, paystubs, employment letters, local
              guarantors, bank statements and credit report. Please speak to our agent to know more.
            </p>
          </div>
        </div>
      </div>
      <Styles/>
    </div>
  );
};

export default Requirements;
